import { useTranslation } from 'react-i18next';

import meysamImage from '@/assets/img/meysam-min.jpeg';
import { SectionWrapper } from '@/features/homepage/components/shared';

function AboutUs() {
	const { t } = useTranslation();

	return (
		<SectionWrapper heading={t('home.aboutUs.heading')} className="px-0">
			<Trainer
				name={t('home.aboutUs.trainers.meysam.name')}
				image={meysamImage}
				bio={t('home.aboutUs.trainers.meysam.bio')}
			/>
		</SectionWrapper>
	);
}

type TrainerProps = {
	name: string;
	image: string;
	bio: string;
};
function Trainer(props: TrainerProps) {
	return (
		<div key={props.name}>
			<img src={props.image} alt={props.name} className="w-full" />
			<div className="px-8 pt-8">
				<h2 className="pb-4 font-bold text-xl">
					<span className="me-2 inline-block size-2 rounded-full bg-ash-400" />
					{props.name}
				</h2>
				<p className="">{props.bio}</p>
			</div>
		</div>
	);
}

export { AboutUs };
